<template>
    <div v-if="isVisible" class="modal-overlay" @click.self="closeModal">
        <div class="modal-content form-contact">
            <button class="close-modal-btn" @click="closeModal">&times;</button>
            <h2>Форма обратной связи</h2>

            <form @submit.prevent="submitForm" class="contact-form">
                <div class="form-group">
                    <label for="name">Ваше имя:</label>
                    <input
                        type="text"
                        id="name"
                        v-model="form.name"
                        class="form-control"
                        :class="{ 'is-invalid': errors.name }"
                    >
                    <div v-if="errors.name" class="invalid-feedback">
                        {{ errors.name[0] }}
                    </div>
                </div>

                <div class="form-group">
                    <label for="email">Ваш email:</label>
                    <input
                        type="email"
                        id="email"
                        class="form-control"
                        v-model="form.email"
                        :class="{ 'is-invalid': errors.email }"
                    >
                    <div v-if="errors.email" class="invalid-feedback">
                        {{ errors.email[0] }}
                    </div>
                </div>

                <div class="form-group">
                    <label for="message">Сообщение:</label>
                    <textarea
                        id="message"
                        class="form-control"
                        v-model="form.message"
                        :class="{ 'is-invalid': errors.message }"
                    ></textarea>
                    <div v-if="errors.message" class="invalid-feedback">
                        {{ errors.message[0] }}
                    </div>
                </div>

                <button type="submit" :disabled="loading">
                    <span v-if="loading">Отправка...</span>
                    <span v-else>Отправить</span>
                </button>

                <div v-if="successMessage" class="success-message">
                    {{ successMessage }}
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
export default {
    props: {
        isVisible: {
            type: Boolean,
            required: true
        }
    },
    emits: ['close'],
    setup(props, { emit }) {
        const form = ref({
            name: '',
            email: '',
            message: ''
        });

        const errors = ref({});
        const loading = ref(false);
        const successMessage = ref('');

        const submitForm = async () => {
            loading.value = true;
            errors.value = {};
            successMessage.value = '';

            try {
                const response = await axios.post('/api/contact', form.value);
                successMessage.value = response.data.message;
                form.value = { name: '', email: '', message: '' };

                setTimeout(() => {
                    closeModal();
                }, 3000);
            } catch (error) {
                if (error.response && error.response.status === 422) {
                    errors.value = error.response.data.errors;
                } else {
                    console.error('Ошибка при отправке формы:', error);
                    successMessage.value = 'Произошла ошибка при отправке формы. Пожалуйста, попробуйте позже.';
                }
            } finally {
                loading.value = false;
            }
        };

        const closeModal = () => {
            emit('close');
            form.value = { name: '', email: '', message: '' };
            errors.value = {};
            successMessage.value = '';
        };

        return {
            form,
            errors,
            loading,
            successMessage,
            submitForm,
            closeModal
        };
    }
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: white;
    padding: 30px;
    border-radius: 8px;
    width: 90%;
    max-width: 600px;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
}

.close-modal-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #666;
}

.contact-form {
    margin-top: 20px;
}

.form-group {
    margin-bottom: 20px;
}

.form-contact,
.form-contact * {
    font-size: 0.95em !important;
}

.form-contact label {
    display: block;
    margin-bottom: 5px;
    font-weight: normal!important;
    font-size: 18px;
}

input, textarea {
    border: 1px solid #ddd;
    border-radius: 4px;
}

textarea {
    min-height: 150px;
}

.is-invalid {
    border-color: #dc3545;
}

.invalid-feedback {
    color: #dc3545;
    font-size: 0.875em;
}

.form-contact button[type="submit"] {
    background-color: #4CAF50;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 10px;
    font-size: 20px;
}

button[type="submit"]:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
}

.success-message {
    margin-top: 20px;
    padding: 10px;
    background-color: #d4edda;
    color: #155724;
    border-radius: 4px;
}

.form-contact h2 {
    margin-top: 0;
    color: #333;
    font-size: 0.8em;
}
</style>
